import Axios from "axios"

export interface Variables {
  asfaRetirement: AsfaVariables
}

export interface AsfaVariables {
  modestSingleYearTotal: number
  comfortableSingleYearTotal: number
}

export class CalculationVariableService {
  private static readonly NAME: string = "calcVars"
  current: Variables | null = null

  async get(): Promise<Variables | null> {
    this.current =
      this.current == null ? this.getFromSessionStorage() : this.current

    return this.current == null ? this.load() : this.current
  }

  private getFromSessionStorage(): Variables | null {
    const json = sessionStorage.getItem(CalculationVariableService.NAME)
    return json == null ? null : JSON.parse(json)
  }

  private removeFromSessionStorage(): void {
    window.sessionStorage.removeItem(CalculationVariableService.NAME)
  }

  private saveToSessionStorage(variables: Variables): void {
    this.removeFromSessionStorage()
    window.sessionStorage.setItem(
      CalculationVariableService.NAME,
      JSON.stringify(variables)
    )
  }

  private async load(): Promise<Variables | null> {
    return Axios.get("/api/calculationVariables")
      .then(response => {
        this.current = response.data
        this.saveToSessionStorage(this.current!)
        return this.current!
      })
      .catch(error => {
        console.error(error.message)
        return null
      })
  }
}
